import { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Blobs = ({ blobs: rawBlobs, name }) => {
    const getBlob = (word) => ({
        word,
        color: '',
        fontColor: '',
        borderColor: '',
        borderRadius: '',
        borderStyle: '',
        borderWidth: '',
    });

    const blobs = rawBlobs?.length ? rawBlobs : name.split(' ').map((x) => getBlob(x));

    return (
        <h1 className='mt-2 mb-4 text-caption'>
            {blobs.map((blob, index) => (
                <Fragment key={'product-blob-' + index}>
                    <span
                        className={cx(
                            'my-0.5 inline-block py-1.5 px-3.5 font-heading text-h2 font-heading-regular',
                            [
                                `${
                                    !blob.borderWidth && (!blob.color || blob.color === '')
                                        ? 'no-blob'
                                        : ''
                                }`,
                            ]
                        )}
                        style={{
                            backgroundColor: blob.color ? blob.color : '#FFFFFF',
                            color: blob.fontColor ? blob.fontColor : '#000000',
                            borderColor: blob.borderColor
                                ? blob.borderColor
                                : blob.borderWidth
                                ? 'black'
                                : 'transparent',
                            borderRadius: blob.borderRadius ? blob.borderRadius : '0',
                            borderStyle: blob.borderStyle ? blob.borderStyle : 'none',
                            borderWidth: blob.borderWidth
                                ? blob.borderWidth
                                : blob.borderStyle === 'dashed' || blob.borderStyle === 'solid'
                                ? '1px'
                                : '0',
                        }}
                    >
                        {blob.word}
                    </span>
                    {` `}
                </Fragment>
            ))}
        </h1>
    );
};

Blobs.defaultProps = {
    blobs: [],
    name: '',
};

Blobs.Proptypes = {
    blobs: PropTypes.array,
    name: PropTypes.string,
};

export default Blobs;
